import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

export default {
  namespaced: true,
  state() {
    return {
      quickEditActive: false,
      clonedKitSku: "",
      skus: [],
      kitSummary: [],
      totalSuggestedRetailPrice: "",
      totalCOGS: "",
      finalRetailPrice: "",
      percentMargin: "",
      shipMethod: "",
      packaging: "",
      productToEdit: {},
      newKit: {
        sku: "",
        skus: [],
        metadata: {
          private: true,
        },
        shipMethod: "",
        packaging: "",
      },
      newProduct: {
        sku: "",
        skus: [],
        metadata: {
          private: true,
        },
        shipMethod: "",
        packaging: "",
      },
      productToCreate: {
        sku: null,
        name: null,
        description: null,
        vendor: null,
        weight: null,
        categories: null,
        cost: null,
        retailPrice: null,
        metadata: {
          private: null,
        },
      },
    };
  },
  mutations,
  getters,
  actions,
};
